import { Center, Loader } from '@highlight-cp/core-ui';

import classes from './centered-absolute-loader.module.css';

interface CenteredAbsoluteLoaderProps {
  dataTestId?: string;
  title?: string;
  description?: string;
}

const CenteredAbsoluteLoader = ({
  dataTestId,
  title,
  description,
}: CenteredAbsoluteLoaderProps) => (
  <Center className={classes.loader} data-testid={dataTestId}>
    <Loader title={title} description={description} />
  </Center>
);

export default CenteredAbsoluteLoader;
